<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
        <p-accordionTab header="{{ 'CAMPANIA.LBL_CAMPANIA' | translate }}" [selected]="tabSeleccionado === 'CAM'">
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-12">
              <h2 class="titulo-pagina">{{ (campania ? 'CAMPANIA.LBL_EDITARCAMPANIA' : 'CAMPANIA.LBL_AGREGARCAMPANIA') | translate }}</h2>
            </div>
          </div>
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fCampanias" name="fCampanias">
            <div class="grid form-group">

              <div class="col-12 md:col-12 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'CAMPANIA.LBL_CODIGO' | translate }}</label>
                  <label *ngIf="campania" class="falso-combo-texto">{{campania.codigo | uppercase }}</label>
                  <input *ngIf="!campania" type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         [maxlength]="10"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'CAMPANIA.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-12 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'CAMPANIA.LBL_NOMBRE' | translate }}</label>
                  <input type="text" pInputText id="nombre"
                         name="nomNombre"
                         autocomplete="off"
                         formControlName="nombre"
                         [maxlength]="50"

                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="!campania && submitted && f.nombre.invalid">
                    {{ 'CAMPANIA.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid">
              <div class="col-12 md:col-12 lg:col-12">
                <h2 class="titulo-pagina">{{'CAMPANIA.LBL_DURACIONCAMPANIA' | translate}}</h2>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'PRODUCTO.LBL_FECHAINICIAL' | translate }}</label>
                  <p-calendar id="idFechaInicial" [showButtonBar]="true" name="nomFechaInicial" [showIcon]="true" [showTime]="false"
                              [monthNavigator]="true" [yearNavigator]="true"
                              [locale]="calPropiedades.informacion" readonlyInput="true" [maxDate]="maxFechaInicial"
                              yearRange="{{calPropiedades.rango}}"
                              formControlName="fechaInicio"
                              dataType="date" (onSelect)="seleccionarFechaInicial($event)"
                              dateFormat="yy'-'mm'-'dd">
                  </p-calendar>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.fechaInicio.invalid">
                    {{ 'PRODUCTO.LBL_FECHAINICIAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'PRODUCTO.LBL_FECHAFINAL' | translate }}</label>
                  <p-calendar id="idFechaFinal" [showButtonBar]="true" name="nomFechaFinal" [showIcon]="true" [showTime]="false"
                              [monthNavigator]="true" [yearNavigator]="true"   yearRange="{{calPropiedades.rango}}"
                              [locale]="calPropiedades.informacion" readonlyInput="true" [minDate]="minFechaFinal"
                              formControlName="fechaFin"
                              dataType="date" (onSelect)="seleccionarFechaFinal($event)"
                              dateFormat="yy'-'mm'-'dd">
                  </p-calendar>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.fechaFin.invalid">
                    {{ 'PRODUCTO.LBL_FECHAFINAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>

            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </p-accordionTab>

        <p-accordionTab header="{{ 'CAMPANIA.LBL_CAMPANIACICLO' | translate }}" [selected]="tabSeleccionado === 'CAMC'"
                        [hidden]="!campania">

          <app-campanias-dcto-ciclos [campania]="campania" *ngIf="campania && campania.idCampania">
          </app-campanias-dcto-ciclos>

        </p-accordionTab>
        <p-accordionTab header="{{ 'CAMPANIA.LBL_CAMPANIAMONTO' | translate }}" [selected]="tabSeleccionado === 'CAMM'"
                        [hidden]="!campania">

          <app-campanias-dcto-montos [campania]="campania" *ngIf="campania && campania.idCampania">
          </app-campanias-dcto-montos>

        </p-accordionTab>

        <p-accordionTab header="{{ 'CAMPANIA.LBL_CAMPANIADESTINOCREDITO' | translate }}" [selected]="tabSeleccionado === 'CAMDM'"
                        [hidden]="!campania">
          <app-campania-descuento-destino [campania]="campania" *ngIf="campania && campania.idCampania"></app-campania-descuento-destino>
        </p-accordionTab>

        <p-accordionTab header="{{ 'CAMPANIA.LBL_CAMPANIADIAMORA' | translate }}" [selected]="tabSeleccionado === 'CAMDI'"
                        [hidden]="!campania">
          <app-campania-descuento-mora [campania]="campania" *ngIf="campania && campania.idCampania"></app-campania-descuento-mora>
        </p-accordionTab>

      </p-accordion>
      <div class="grid form-footer-buttons" *ngIf="campania && campania.idCampania">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
